import React from 'react';
import { IParagraph, IInput } from '../../../../utils/types/contentful';
import { TabListItem } from '../../../UI/Navigation/Tabs/Tab';
import { formatContentfulComponentProps } from '../../../../utils/globals';

export interface ShopBestselectorHeaderProps {
  label: IParagraph;
  input: IInput;
  collection: any;
  setCollection: Function;
}

export const ShopSelectorHeader: React.FC<ShopBestselectorHeaderProps> = ({
  list,
  collection,
  setCollection,
}) => (
  <div className='flex border-t h-16 w-full overflow-x-scroll no-scrollbar justify-start lg:justify-center'>
    {list.map((item, index) => {
      const { label, color } = formatContentfulComponentProps(item);
      return (
        <div
          role='button'
          tabIndex={index}
          onKeyDown={() => setCollection(index)}
          className='w-1/5 min-w-1/3 lg:min-w-min h-full flex justify-center items-center'
          onClick={() => setCollection(index)}>
          <TabListItem
            borderPlacement='top'
            label={{
              ...label,
              size: 'lg',
              weight: index === collection ? 'medium' : 'light',
            }}
            color={color}
            selected={index === collection}
          />
        </div>
      );
    })}
  </div>
);
